module.exports = __webpack_public_path__ + "img/personel-6.png";